export default __webpack_public_path__ + "static/media/before-you-start.14392b4c.png";